import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import React, { useState } from "react";
import OTPInput from "react-otp-input";

const inputStyle = {
  border: "1px solid #CFD3DB",
  borderRadius: 6,
  width: 44,
  height: 44,
  textAlign: "center",
  fontSize: 16,
};

const ChangePin = ({
  oldPasskey,
  setOldPasskey,
  newPasskey,
  setNewPasskey,
  errorMsg,
}) => {
  const [showOldPasskey, setShowOldPaskey] = useState(false);
  const [showNewPasskey, setShowNewPaskey] = useState(false);

  return (
    <>
      <Grid container spacing={2} marginBottom={2}>
        <Grid xs={12} item>
          <h6
            className="add-edit-patient-sub-header"
            style={{ textAlign: "center", marginBlock: 8 }}
          >
            Old PIN
          </h6>
          <Box className="d-flex align-items-center">
            <OTPInput
              value={oldPasskey}
              onChange={setOldPasskey}
              numInputs={6}
              shouldAutoFocus
              inputType={showOldPasskey ? "tel" : "password"}
              renderInput={(props) => (
                <input
                  {...props}
                  onInput={(e) => {
                    if (!/^\d$/.test(e.target.value)) {
                      e.target.value = "";
                    }
                  }}
                  style={{
                    ...inputStyle,
                    outline: props.focused ? "2px solid #CFD3DB" : "none",
                  }}
                />
              )}
              containerStyle={{
                width: "100%",
                justifyContent: "center",
                gap: 10,
              }}
            />
            <IconButton onClick={() => setShowOldPaskey((prev) => !prev)}>
              {showOldPasskey ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </Box>
        </Grid>

        <Grid xs={12} item>
          <h6
            className="add-edit-patient-sub-header"
            style={{ textAlign: "center", marginBottom: 6 }}
          >
            New PIN
          </h6>
          <Box className="d-flex align-items-center">
            <OTPInput
              value={newPasskey}
              onChange={setNewPasskey}
              numInputs={6}
              inputType={showNewPasskey ? "tel" : "password"}
              renderInput={(props) => (
                <input
                  {...props}
                  onInput={(e) => {
                    if (!/^\d$/.test(e.target.value)) {
                      e.target.value = "";
                    }
                  }}
                  style={{
                    ...inputStyle,
                    outline: props.focused ? "2px solid #CFD3DB" : "none",
                  }}
                />
              )}
              containerStyle={{
                width: "100%",
                justifyContent: "center",
                gap: 10,
              }}
            />
            <IconButton onClick={() => setShowNewPaskey((prev) => !prev)}>
              {showNewPasskey ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </Box>
          {errorMsg && (
            <Typography
              gutterBottom
              color={"#d32f2f"}
              textAlign={"center"}
              marginTop={1}
            >
              {errorMsg}
            </Typography>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default ChangePin;
